import { render, staticRenderFns } from "./BSMbs.vue?vue&type=template&id=71255cd3&"
import script from "./BSMbs.vue?vue&type=script&lang=js&"
export * from "./BSMbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports